import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';

import { messages } from './messages';

const styles = cssMap({
	// minHeight roughly matches two rows of AppCards to avoid layout shift when the grid mounts.
	container: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: '240px',
		width: '100%',
	},
});

/**
 * Centered spinner shown in the discovery grid while TAP traits load.
 *
 * The grid is gated on `tapTraitsLoaded` to avoid showing apps in default order then visibly
 * re-ordering once ranking data arrives. Extracted as its own component so it can be rendered
 * directly from examples and unit tests without mocking the data-fetching hook.
 */
export const DiscoveryContentLoadingState = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.container} testId="discovery-content-loading-state">
			<Spinner label={formatMessage(messages.loadingApps)} size="medium" />
		</Box>
	);
};
